import React from "react";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import DashboardHeaderLayout from "./DashboardHeaderLayout";
import config from "./config/config";
import "./App.css";
import "./assets/css/font.css";
import Home from "./component/Pages/home";
import Bnbstaking from "./component/Others/bnbstaking";
import Faq from "./component/Pages/faq";
import Signup from "./component/signup";
import Forgetpassword from "./component/forgetpassword";
// -----------------------
import Dashboard from "./component/dashboard";
import Wallethistory from "./component/wallethistory";
import Deposit from "./component/deposit";
import Matchingbonus from "./component/matchingbonus";
import Withdraw from "./component/withdraw";
import Profile from "./component/profile";
// ---------------
import Referral from "./component/referral";
import Referraltree from "./component/referraltree";
import Changepassword from "./component/changepassword";
import { Helmet } from "react-helmet";
import TermsAndConditions from "./component/Pages/TermsAndCondition/TermsAndCondition";
import FreeSignupTerms from "./component/Pages/TermsAndCondition/FreeSignupTerms";

import PrivacyPolicy from "./component/Pages/TermsAndCondition/PrivacyPolicy";
import MintNft from "./component/MintNft";

// --------------------

import Stepmint from "./component/Stepmintmobile";
import Mobilefooter from "./component/Stepmintmobile/mobilefooter";
import StepDashboard from "./component/StepDashboard";
import ScrollToTop from "./directives/ScrollToTop";
import ProtectedRoutes from "./directives/ProtectedRoutes";
import Cookies from "js-cookie";
import LoyaltyBonusDetails from "./component/LoyaltyBonusDetails";
import Login from "./component/newLogin/login";
import Amlpolicy from "./component/Pages/TermsAndCondition/AmlPolicy";
import Disclaimer from "./component/Pages/TermsAndCondition/Disclaimer";
import Riskdisclosure from "./component/Pages/TermsAndCondition/Riskdisclosure";
import Ticketterms from "./component/Pages/TermsAndCondition/Ticketterms";
import PlanTermsAndConditions from "./component/Pages/TermsAndCondition/planTermsAndConditions";
import SignupTermsCondition from "./component/Pages/TermsAndCondition/SignupTermsCondition";
import AlphaPlanTermsAndConditions from "./component/Pages/TermsAndCondition/alphaplanTermsAndConditions";
import NotificationView from "./component/Notification/NotificationView";
import { NotificationProvider } from "./component/Notification/NotificationContext";
import WithdrawReferral from "./component/WithdrawReferral";
import VestingWallateHistory from "./component/vestingWallateHistory";
import BusinessExpiry from "./component/BusinessExpiry";
import Staking from "./component/Staking/Staking";
import BusinessWalletTransfer from "./component/BusinessWalletTransfer";
// import Nftbox from "./component/NFTBox/Nftbox";
// import NftboxPurchaseDetails from "./component/NFTBox/NftboxPurchaseDetails";
import NftboxDetails from "./component/NFTBox/NftboxDetails";
import BuyNowNftBox from "./component/BuyNow/BuyNowNftBox";
import NftBoxTermsAndCondition from "./component/Pages/TermsAndCondition/NftBoxTermsAndCondition";
import UserBusinessReport from "./component/UserBusinesReport";
import NewHome from "./component/newLandingPage/NewHome";
import NewAboutUs from "./component/newLandingPage/NewAboutUs";
import NewTestimonials from "./component/newLandingPage/NewTestimonials";
import NewContactUs from "./component/newLandingPage/NewContactUs";
import NewHowItWorks from "./component/newLandingPage/NewHowItWorks";
import MlmTree from "./component/Mlmtree";
import Migration from "./component/Wallet Migration/Migration";
import MigrationHistory from "./component/Wallet Migration/MigrationHistory";
import { useSelector } from "react-redux";
import Airdrop from "./component/Airdrop/Airdrop";
import NFTCoinWithdraw from "./component/WithdrawComponents/NFTCoinWithdraw";
import CreditTransfer from "./component/CreditTransfer";
import CreditTransferHistory from "./component/CreditBalanceHistory";
import BusinessProposal from "./component/BusinessProposalModule/BusinessProposal";

const RouterComponent = () => {
  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
      Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
    );
  const userData = useSelector((state) => state.userData.userData);
  const isPopupActive = JSON.parse(localStorage.getItem("is_popup_active"));

  return (
    <BrowserRouter>
      {/* <Toaster /> */}
      <ScrollToTop />
      <div>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="description"
            content="Start earning with the best way to make money online today by joining Stepmint. Join millions of people who are living healthier and wealthier lives with this platform."
          />
          <meta
            name="title"
            content="Unlock Wealth and Wellness | Start Earning with Stepmint Today"
          />
          <meta
            name="keywords"
            content="Stepmint, make money online, wealth, wellness, earning online"
          />
          <meta name="author" content="StepMint" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        <NotificationProvider>
          <Routes>
            <Route path={`${config.baseUrl}`} element={<NewHome />} />
            <Route
              path={`${config.baseUrl}about_us`}
              element={<NewAboutUs />}
            />

            {/* <Route
              path={`${config.baseUrl}testimonial`}
              element={<NewTestimonials />}
            /> */}
            <Route
              path={`${config.baseUrl}newcontactus`}
              element={<NewContactUs />}
            />
            <Route
              path={`${config.baseUrl}contactus`}
              element={<NewContactUs />}
            />
            <Route
              path={`${config.baseUrl}how-it-works`}
              element={<NewHowItWorks />}
            />
            <Route path={`${config.baseUrl}aboutus`} element={<Home />} />
           {/*  <Route path={`${config.baseUrl}signup`} element={<Signup />} />
            <Route
              path={`${config.baseUrl}signup/:referral_address`}
              element={<Signup />}
            />
            */}
            <Route
              path={`${config.baseUrl}termsandconditions`}
              element={<TermsAndConditions />}
            />
            <Route
              path={`${config.baseUrl}amlpolicy`}
              element={<Amlpolicy />}
            />
            <Route
              path={`${config.baseUrl}disclaimer`}
              element={<Disclaimer />}
            />
            <Route
              path={`${config.baseUrl}riskdisclosure`}
              element={<Riskdisclosure />}
            />
            <Route
              path={`${config.baseUrl}ticketterms`}
              element={<Ticketterms />}
            />
            <Route
              path={`${config.baseUrl}plantermsandconditions`}
              element={<PlanTermsAndConditions />}
            />
            <Route
              path={`${config.baseUrl}alphaplantermsandconditions`}
              element={<AlphaPlanTermsAndConditions />}
            />
            <Route
              path={`${config.baseUrl}signuptermsandconditions`}
              element={<SignupTermsCondition />}
            />
            <Route
              path={`${config.baseUrl}freesignupterms`}
              element={<FreeSignupTerms />}
            />
            <Route
              path={`${config.baseUrl}nftboxtermsandcondition`}
              element={<NftBoxTermsAndCondition />}
            />
            <Route
              path={`${config.baseUrl}privacypolicy`}
              element={<PrivacyPolicy />}
            />
            {/* <Route
              path={`${config.baseUrl}packageplan`}
              element={<Packageplan />}
            /> */}
            {/* <Route
              path={`${config.baseUrl}nftdetail/:id`}
              element={<BuyNow2 />}
            /> */}
            {/* <Route
              path={`${config.baseUrl}alphanftdetail/:id`}
              element={<BuyNowAlpha />}
            /> */}
            {/* <Route path={`${config.baseUrl}nftdetail`} element={<BuyNow2 />} /> */}
            {/* -------Mobile------- */}
            <Route
              path={`${config.baseUrl}stepmint_mobile`}
              element={<Stepmint />}
            />
            <Route
              path={`${config.baseUrl}mobilefooter`}
              element={<Mobilefooter />}
            />
            <Route
              path={`${config.baseUrl}loyaltyBonusDetails/:loyaltyDetailsDate`}
              element={<LoyaltyBonusDetails />}
            />
            <Route
              path={`${config.baseUrl}businessexpiry`}
              element={<BusinessExpiry />}
            />
            <Route path={`${config.baseUrl}login`} element={<Login />} />
            <Route
              path={`${config.baseUrl}forgetpassword`}
              element={<Forgetpassword />}
            />
            <Route
              path={`${config.baseUrl}changepassword/:token`}
              element={<Changepassword />}
            />
            <Route path={`${config.baseUrl}faq`} element={<Faq />} />

            {/* {/ Dashboard Header /} */}
            <Route element={<ProtectedRoutes />}>
              <Route element={<DashboardHeaderLayout />}>

                {/* <Route path={`${config.baseUrl}airdrop`} element={<Airdrop />} /> */}
                {isPopupActive ? (
                  <Route path={`${config.baseUrl}airdrop`} element={<Airdrop />} />
                ) : (
                  
                  <Route
                    path="*"
                    element={<Navigate to={`${config.baseUrl}dashboard`} replace />}
                  />
                )}

                <Route
                  path={`${config.baseUrl}mlmtree`}
                  element={<MlmTree />}
                />
                <Route
                  path={`${config.baseUrl}mintnft/:id`}
                  element={<MintNft />}
                />
                <Route
                  path={`${config.baseUrl}bnbstaking`}
                  element={<Bnbstaking />}
                />
                <Route
                  path={`${config.baseUrl}dashboard`}
                  element={<Dashboard />}
                />
                <Route
                  path={`${config.baseUrl}wallethistory`}
                  element={<Wallethistory />}
                />
                <Route
                  path={`${config.baseUrl}deposit`}
                  element={<Deposit />}
                />
                <Route
                  path={`${config.baseUrl}matchingbonus`}
                  element={<Matchingbonus />}
                />
                <Route
                  path={`${config.baseUrl}useractivity`}
                  element={<StepDashboard />}
                />
                <Route
                  path={`${config.baseUrl}referralwallet`}
                  element={
                    loginData?.is_email_verify && loginData?.bnb_address ? (
                      <WithdrawReferral />
                    ) : (
                      <Wallethistory />
                    )
                  }
                />
                  <Route
                  path={`${config.baseUrl}nftcoinwwallet`}
                  element={
                    loginData?.is_email_verify && loginData?.bnb_address ? (
                      <NFTCoinWithdraw />
                    ) : (
                      <Wallethistory />
                    )
                  }
                />
                <Route
                  path={`${config.baseUrl}staking`}
                  element={
                    loginData?.is_email_verify && loginData?.bnb_address ? (
                      <Staking />
                    ) : (
                      <Wallethistory />
                    )
                  }
                />
                {/* <Route
                  path={`${config.baseUrl}business-proposal`}
                  element={
                    loginData?.bnb_address ? (
                      <BusinessProposal />
                    ) : (
                      <Wallethistory />
                    )
                  }
                />                 */}
                <Route
                  path={`${config.baseUrl}businesswallettransfer`}
                  element={
                    loginData?.is_email_verify && loginData?.bnb_address ? (
                      <BusinessWalletTransfer />
                    ) : (
                      <Wallethistory />
                    )
                  }
                />
                <Route
                  path={`${config.baseUrl}withdraw`}
                  element={
                    loginData?.is_email_verify && loginData?.bnb_address ? (
                      <Withdraw />
                    ) : (
                      <Wallethistory />
                    )
                  }
                />
                <Route
                  path={`${config.baseUrl}profile`}
                  element={<Profile />}
                />
                <Route
                  path={`${config.baseUrl}referral`}
                  element={<Referral />}
                />

                {/* <Route
                  path={`${config.baseUrl}BuyNowNftBox/:nftBoxValue`}
                  element={<BuyNowNftBox />}
                /> */}

                <Route
                  path={`${config.baseUrl}BuyNftBoxAnant/:nftBoxValue`}
                  element={<BuyNowNftBox />}
                />

                <Route
                  path={`${config.baseUrl}referraltree`}
                  element={<Referraltree />}
                />
                <Route
                  path={`${config.baseUrl}stepmint_mobile`}
                  element={<Stepmint />}
                />
                <Route
                  path={`${config.baseUrl}mobilefooter`}
                  element={<Mobilefooter />}
                />

                {/* <Route
                  path={`${config.baseUrl}nftbox`}
                  element={<Nftbox />}
                /> */}

                <Route
                  path={`${config.baseUrl}notifications`}
                  element={<NotificationView />}
                />
                {/* <Route
                  path={`${config.baseUrl}NftboxPurchaseDetails/:nftBoxValue`}
                  element={<NftboxPurchaseDetails />}
                /> */}
                <Route
                  path={`${config.baseUrl}nftboxdetails`}
                  element={<NftboxDetails />}
                />
                <Route
                  path={`${config.baseUrl}vestingWallateHistory`}
                  element={<VestingWallateHistory />}
                />
                <Route
                  path={`${config.baseUrl}staking`}
                  element={<Staking />}
                />
                <Route
                  path={`${config.baseUrl}UserBusinessReport`}
                  element={<UserBusinessReport />}
                />

                <Route
                  path={`${config.baseUrl}Migration`}
                  element={userData?.step_balance > 0 || userData?.referral_wallet_balance > 0 ? <Migration /> : <Navigate to={`${config.baseUrl}dashboard`}
                  />
                  }
                />
                <Route
                  path={`${config.baseUrl}MigrationHistory`}
                  element={<MigrationHistory />}
                />
                <Route
                  path={`${config.baseUrl}CreditTransfer`}
                  element={
                    loginData?.is_email_verify && loginData?.bnb_address ? (
                      <CreditTransfer />
                    ) : (
                      <Wallethistory />
                    )
                  }
                />
                <Route
                  path={`${config.baseUrl}CreditTransferHistory`}
                  element={<CreditTransferHistory />}
                />
                
                
              </Route>
            </Route>
          </Routes>
        </NotificationProvider>
      </div>
    </BrowserRouter>
  );
};
export default RouterComponent;
